export async function fetchWithCsrf<T>(
  url: string,
  options: RequestInit = {},
): Promise<T> {
  const csrfToken = document.cookie.replace(
    /(?:(?:^|.*;\s*)csrftoken\s*=\s*([^;]*).*$)|^.*$/,
    '$1',
  );
  if (csrfToken) {
    options.headers = {
      ...options.headers,
      'X-CSRFToken': csrfToken,
    };
  }

  return await apiRequest<T>(url, options);
}

async function apiRequest<T>(
  endpoint: string,
  options: RequestInit = {},
): Promise<T> {
  return fetch(endpoint, {
    credentials: 'include',
    headers: {
      'Content-Type': 'application/json',
      ...(options.headers || {}),
    },
    ...options,
  }).then((response) => response.json() as Promise<T>);
}
